import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Terms from "@/pages/Terms";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminHome from "@/pages/admin/AdminHome";
import AdminFormSubmissions from "@/pages/admin/FormSubmissions";

function App() {
  return (
    <AuthProvider>
      <div className="App retro-gradient-bg min-h-screen paper-grain">
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard/*" element={<Navigate to="/admin/submissions" replace />} />
            <Route path="/unlock" element={<Navigate to="/" replace />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminHome />} />
              <Route path="submissions" element={<AdminFormSubmissions />} />
              <Route path="*" element={<Navigate to="/admin/submissions" replace />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
